import { Component } from 'react';
import Page from '@ui/components/ams/Pages/Page';
import AMS from '@ui/components/ams';
import { PAGE_CATEGORY } from '@lib/constants';
import { pushPageViewEvent } from '@lib/atm';
import { withServerSideProps } from '@lib/withServerSideProps';
import { CategoryDetailsPageDocument, type CategoryDetailsPageQuery } from '@graphql/pages/category-details.generated';
import type { ServerSidePageProps } from '@lib/withServerSideProps';

class CategoryDetails extends Component<ServerSidePageProps<CategoryDetailsPageQuery>> {
  PAGE_NAME = 'category';

  componentDidMount() {
    const {
      userSessionData: {
        userData,
      },
      locale,
      pageData,
    } = this.props;
    const currentCategory = pageData.category?.[0];
    const pageTitle = currentCategory?.name;
    const {
      location: {
        search: currentSearch,
      },
    } = window;
    const searchParams = new URLSearchParams(currentSearch || '');
    const selectedSubCategorySlug = searchParams.getAll('subCategory')[0] || '';
    const selectedSubCategory = (currentCategory?.subCategories || []).find(
      (subCategory) => subCategory?.slug === selectedSubCategorySlug,
    );

    pushPageViewEvent(
      window,
      userData,
      {
        locale,
        sections: [
          this.PAGE_NAME,
          currentCategory?.analyticsSlug ?? '',
          selectedSubCategory?.analyticsSlug ?? '',
        ],
        title: pageTitle ?? '',
      },
    );
  }

  render() {
    const {
      pageData,
      locale,
      requestData,
      userSessionData,
      globalPageData,
    } = this.props;

    const {
      category,
      globalCategoryConfig = {},
      pageAds,
    } = pageData;

    const categoryData = category?.[0] ?? {};
    const pageTitle = category?.[0]?.name || '';

    return (
      <Page
        pageName={PAGE_CATEGORY}
        pageTitle={pageTitle}
        metaDescription={category?.[0]?.metaDescription}
        globalPageData={globalPageData}
        requestData={requestData}
        userSessionData={userSessionData}
        pageAds={pageAds}
      >
        <AMS.CategoryPage
          {...categoryData}
          {...globalCategoryConfig}
          locale={locale}
        />
      </Page>
    );
  }
}

export const getServerSideProps = withServerSideProps({
  pageQuery: CategoryDetailsPageDocument,
  getPageQueryVariables: ({ query }) => ({
    categorySlug: Array.isArray(query.categorySlug) ? query.categorySlug[0] : query.categorySlug ?? '',
    adsPageSlug: Array.isArray(query.adsPageSlug) ? query.adsPageSlug[0] : query.adsPageSlug,
  }),
});

export default CategoryDetails;
